import {
  WORKER_DETAILS_LOADING,
  WORKER_DETAILS_SUCCESS,
  WORKER_DETAILS_FAILED,
  RESET_WORKER_DETAILS,
  WORKER_ROLES_LOADING,
  WORKER_ROLES_SUCCESS,
  WORKER_ROLES_FAILED,
  WORKER_SCHEDULE_SUCCCESS,
  ROLE_UPDATE
} from '../CONSTANTS'
import _ from 'lodash';

const initialState = {
  loading : false,
  workerDocument : {},
  loadingRoles: false,
  workerRoles : {},
  workerSchedule: {},
  enabledRoles: {}
}

export const addEditWorker = (state={...initialState}, action) => {
  const {type, payload} = action;
  switch(type){
    case  WORKER_DETAILS_FAILED : 
      return {
        ...state, 
        loading : false,
        error: payload
      }
      case  WORKER_ROLES_FAILED : 
      return {
        ...state, 
        loadingRoles : false,
        error: payload
      }
    case  WORKER_DETAILS_LOADING : 
    console.log("Inside WORKER_DETAILS_LOADING")
      return {
        ...state, 
        loading : payload
      }
    case  WORKER_ROLES_LOADING : 
      console.log("Inside WORKER_ROLES_LOADING")
        return {
          ...state, 
          loadingRoles : payload
        }
    case  WORKER_DETAILS_SUCCESS : 
      return {
        ...state, 
        loading : false,
        workerDocument : _.cloneDeep(payload || {})
      }
    case  WORKER_ROLES_SUCCESS : 
      const {workerRoles={}, enabledRoles={}} = payload || {};
      return {
        ...state, 
      //  loadingRoles : false,
        workerRoles : _.cloneDeep(workerRoles || {}),
        enabledRoles: _.cloneDeep(enabledRoles || {})
      }
    case  WORKER_SCHEDULE_SUCCCESS : 
      return {
        ...state, 
      //  loadingRoles : false,
        workerSchedule : _.cloneDeep(payload || {})
      }
    case  ROLE_UPDATE : 
      const { key, value, isEnabled } = payload || {};
      console.log("ROLE_UPDATE", key, value)
      return {
        ...state, 
      //  loadingRoles : false,
      workerRoles:{
        ...state.workerRoles,
        [key] : _.cloneDeep(value)
      },
      enabledRoles: {
        ...state.enabledRoles,
        [key]: isEnabled ? true : false
      }
      }
    case RESET_WORKER_DETAILS : 
    return {
      ...state, 
      ...initialState
    }
    default : return {...state};
  }
}

export default addEditWorker;